(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9835],{

/***/ 70747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23094);

function productChange(product) {
    return {
        product: product,
        type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_CHANGE */ .GE
    };
}
function hospitalChange(product) {
    return {
        product: product,
        type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .HOSPITAL_CHANGE */ .Dy
    };
}
function extrasChange(product) {
    return {
        product: product,
        type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .EXTRAS_CHANGE */ .qA
    };
}
function clearCart() {
    return {
        type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .CLEAR_CART */ .qX
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    clearCart: clearCart,
    extrasChange: extrasChange,
    hospitalChange: hospitalChange,
    productChange: productChange
});


/***/ }),

/***/ 15311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23094);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);



/**
 * Load products into state.
 *
 * @param {string|string[]} productIds - One or a list of product ids.
 * @returns {object} Action.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
function load(productIds) {
    var array = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isString)(productIds) ? [
        productIds
    ] : productIds;
    return {
        productIds: array,
        // @ts-expect-error - Automatic, Please fix when editing this file
        promise: function(api) {
            return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].loadProducts */ .Z.loadProducts(api, array);
        },
        types: [
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD */ .F9,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_SUCCESS */ .cx,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_FAIL */ .w2
        ]
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    load: load
});


/***/ }),

/***/ 84076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ data_loader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 5 modules
var _create_super = __webpack_require__(16567);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/assert/assert.js
var assert = __webpack_require__(27596);
var assert_default = /*#__PURE__*/__webpack_require__.n(assert);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/utils/api-to-alert/index.js
var api_to_alert = __webpack_require__(23257);
var api_to_alert_default = /*#__PURE__*/__webpack_require__.n(api_to_alert);
// EXTERNAL MODULE: ./src/client/components/loading-error-alert/styles.module.sass
var styles_module = __webpack_require__(7550);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/loading-error-alert/index.tsx







// @ts-expect-error - Automatic, Please fix when editing this file
var shouldShowLoadingErrorAlert = function(loadingError) {
    return (0,fp.isPlainObject)(loadingError);
};
var LoadingErrorAlert = function(param) {
    var loadingError = param.loadingError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Section */.$0, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Wrapper */.im, {
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Alert */.bZ, (0,_object_spread/* default */.Z)({}, api_to_alert_default()(loadingError)))
            })
        })
    });
};
/* harmony default export */ var loading_error_alert = (LoadingErrorAlert);


// EXTERNAL MODULE: ./src/client/components/loading-spinner/index.tsx
var loading_spinner = __webpack_require__(30950);
;// CONCATENATED MODULE: ./src/client/components/data-loader/index.tsx











var dataLoader = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // @ts-expect-error - Automatic, Please fix when editing this file
    assert_default()((0,fp.isFunction)(options.selectIsDataLoaded), "selectIsDataLoaded option must be a function");
    // @ts-expect-error - Automatic, Please fix when editing this file
    assert_default()((0,fp.isFunction)(options.selectLoadingError), "selectLoadingError option must be a function");
    // @ts-expect-error - Automatic, Please fix when editing this file
    var mapStateToProps = function(state, props) {
        return {
            // @ts-expect-error - Automatic, Please fix when editing this file
            isLoaded: options.selectIsDataLoaded(state, props),
            // @ts-expect-error - Automatic, Please fix when editing this file
            loadingError: options.selectLoadingError(state, props),
            state: state
        };
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    var mapDispatchToProps = function(dispatch) {
        return {
            dispatch: dispatch
        };
    };
    // @ts-expect-error - Automatic, Please fix when editing this file
    return function(WrappedComponent) {
        var DataLoader = /*#__PURE__*/ function(PureComponent) {
            "use strict";
            (0,_inherits/* default */.Z)(DataLoader, PureComponent);
            var _super = (0,_create_super/* default */.Z)(DataLoader);
            function DataLoader() {
                (0,_class_call_check/* default */.Z)(this, DataLoader);
                return _super.apply(this, arguments);
            }
            var _proto = DataLoader.prototype;
            // DEPRECATED: not in use for server-side data fetching in NextJS
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                var _props = this.props, dispatch = _props.dispatch, history = _props.history, loadData = _props.loadData, match = _props.match, state = _props.state;
                // Define loadData prop in top-level routes config ('../../routes/index.jsx')
                if ((0,fp.isFunction)(loadData)) {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    loadData(state, dispatch, match.params, history);
                }
            };
            // DEPRECATED: not in use for server-side data fetching in NextJS
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
                if (prevProps.isLoaded && !this.props.isLoaded) {
                    var _props = this.props, dispatch = _props.dispatch, history = _props.history, loadData = _props.loadData, match = _props.match, state = _props.state;
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    loadData(state, dispatch, match.params, history);
                }
            };
            // @ts-expect-error - Automatic, Please fix when editing this file
            _proto.render = function render() {
                var _props = this.props, isLoaded = _props.isLoaded, loadingError = _props.loadingError;
                if (!isLoaded) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_spinner/* default */.Z, {});
                }
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'timeout' does not exist on type '{ code?: string | undefined; explanation?: string | ReactElement<any, string | JSXElementConstructor<any>> | undefined; response?: string | undefined; }'.
                var errorToShow = (loadingError === null || loadingError === void 0 ? void 0 : loadingError.timeout) ? {
                    explanation: "It seems our servers are taking too long to respond. Please try again later."
                } : loadingError;
                if (shouldShowLoadingErrorAlert(errorToShow)) {
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_error_alert, {
                        loadingError: errorToShow
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, (0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                    "dispatch",
                    "state"
                ], this.props)));
            };
            return DataLoader;
        }(react.PureComponent);
        // @ts-expect-error - Automatic, Please fix when editing this file
        DataLoader.defaultProps = {
            history: {
                push: fp.noop
            },
            isLoaded: false,
            loadData: null,
            loadingError: null,
            match: {
                params: {
                    id: null
                }
            }
        };
        return (0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(DataLoader);
    };
};
/* harmony default export */ var data_loader = (dataLoader);


/***/ }),

/***/ 30950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90937);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_3__);




/**
 * @deprecated If you need to display a transition state for the entire content of a page please
 * prefer LoadingContent to avoid breaking accessibility rules.
 */ var LoadingSpinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_sass__WEBPACK_IMPORTED_MODULE_3___default().section),
        "data-testid": "loading-spinner",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Section */ .$0, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Wrapper */ .im, {
                size: "large",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$j, {})
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingSpinner);


/***/ }),

/***/ 4035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ needs_product_data_loader; }
});

// EXTERNAL MODULE: ./src/client/components/data-loader/index.tsx + 1 modules
var data_loader = __webpack_require__(84076);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var es = __webpack_require__(22222);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./src/client/utils/get-product-ids-from-needs/index.ts + 2 modules
var get_product_ids_from_needs = __webpack_require__(95890);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
// EXTERNAL MODULE: ./src/client/selectors/select-needs-product-type/index.ts
var select_needs_product_type = __webpack_require__(82488);
// EXTERNAL MODULE: ./src/client/selectors/select-needs-type/index.ts
var select_needs_type = __webpack_require__(69286);
// EXTERNAL MODULE: ./src/client/selectors/select-raw-product/index.ts
var select_raw_product = __webpack_require__(96980);
;// CONCATENATED MODULE: ./src/client/selectors/select-has-loaded-needs-products/index.ts







var selectHasLoadedNeedsProducts = (0,es.createSelector)([
    select_raw_product/* default */.Z,
    select_needs_product_type/* default */.Z,
    select_needs_type/* default */.Z,
    select_customer/* default */.Z
], function(products, needsProductType, needsType, customer) {
    var hospitalExcess = customer.hospitalExcess;
    var loadedProductIds = (0,fp.flow)((0,fp.pick)([
        "data"
    ]), (0,fp.flatMap)(fp.keys))(products);
    var productIdsFromNeeds = (0,get_product_ids_from_needs/* default */.Z)({
        hospitalExcess: hospitalExcess,
        needsProductType: needsProductType,
        needsType: needsType
    });
    var allLoaded = (0,fp.every)(function(productId) {
        return (0,fp.includes)(productId, loadedProductIds);
    }, productIdsFromNeeds);
    var ref, ref1;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'loading' does not exist on type 'never'.
    return allLoaded && (0,fp.isEmpty)((ref = products === null || products === void 0 ? void 0 : products.loading) !== null && ref !== void 0 ? ref : false) || !(0,fp.isEmpty)((ref1 = products === null || products === void 0 ? void 0 : products.error) !== null && ref1 !== void 0 ? ref1 : null);
});
/* harmony default export */ var select_has_loaded_needs_products = (selectHasLoadedNeedsProducts);

// EXTERNAL MODULE: ./src/client/selectors/select-products-error/index.ts
var select_products_error = __webpack_require__(50359);
;// CONCATENATED MODULE: ./src/client/components/needs-product-data-loader/index.ts



/* harmony default export */ var needs_product_data_loader = ((0,data_loader/* default */.Z)({
    selectIsDataLoaded: select_has_loaded_needs_products,
    selectLoadingError: select_products_error/* default */.Z
}));


/***/ }),

/***/ 77484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14890);
/* harmony import */ var _actions_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70747);
/* harmony import */ var _actions_customer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91395);
/* harmony import */ var _actions_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18826);
/* harmony import */ var _actions_price__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77061);
/* harmony import */ var _actions_product__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15311);






/* harmony default export */ __webpack_exports__["Z"] = ({
    defaultProps: {
        needsType: null
    },
    // @ts-expect-error - Automatic, Please fix when editing this file
    mapDispatchToProps: function(dispatch) {
        return {
            actions: {
                cart: (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .bindActionCreators */ .DE)(_actions_cart__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, dispatch),
                customer: (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .bindActionCreators */ .DE)(_actions_customer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, dispatch),
                modal: (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .bindActionCreators */ .DE)(_actions_modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, dispatch),
                price: (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .bindActionCreators */ .DE)(_actions_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, dispatch),
                product: (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .bindActionCreators */ .DE)(_actions_product__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, dispatch)
            }
        };
    }
});


/***/ }),

/***/ 50359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _select_raw_product__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96980);

var ref;
// @ts-expect-error - Automatic, Please fix when editing this file
var selectProductsError = function(state) {
    var ref1;
    return (ref = (ref1 = (0,_select_raw_product__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(state)) === null || ref1 === void 0 ? void 0 : ref1.error) !== null && ref !== void 0 ? ref : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (selectProductsError);


/***/ }),

/***/ 51552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _get_future_date__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84701);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2798);


var getCustomerHasChanged = function(customer, useFutureEffectiveDate) {
    var emptyProductId = "";
    return _models_price__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getKey */ .Z.getKey(emptyProductId, customer, {
        date: (0,_get_future_date__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(useFutureEffectiveDate)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (getCustomerHasChanged);


/***/ }),

/***/ 84701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47569);

var getFutureDate = function(useFutureEffectiveDate) {
    return useFutureEffectiveDate ? _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FUTURE_EFFECTIVE_DATE */ .Z.FUTURE_EFFECTIVE_DATE : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFutureDate);


/***/ }),

/***/ 95890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ get_product_ids_from_needs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/constants/lib/src/index.js
var src = __webpack_require__(13294);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
;// CONCATENATED MODULE: ./src/client/utils/exclude-choosable-for-needs/index.ts



// Generally the products for certain needs journeys are defined in the constants
// repo. However there is sometimes the need to exclude some choosable products
// for a particular journey (eg exclude choosable 60 products from all extras product listing)
var excludeChoosableForNeeds = function(param) {
    var needsProductType = param.needsProductType, needsType = param.needsType, productIds = param.productIds;
    if (needsType === src.CUSTOMER_NEEDS.EXTRAS_COVER && needsProductType === src.CUSTOMER_NEEDS.ALL) {
        return (0,fp.difference)(productIds)(ui.CHOOSABLE_60_PRODUCTS);
    }
    return productIds;
};
/* harmony default export */ var exclude_choosable_for_needs = (excludeChoosableForNeeds);

;// CONCATENATED MODULE: ./src/client/utils/filter-ids-by-excess/index.ts

/**
 *  This util filters product ids with excess-<number> in the name.
 *  Legacy products with co-pay aren’t sold on the sales site anymore, so they are not factored into this filter.
 *
 * @param {object} param - An object.
 * @param {string} param.hospitalExcess -  Excess amount to filter for ids for.
 * @param {string[]} param.productIds -  A list of products ids which will be filtered.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
var filterIdsByExcess = function(param) {
    var hospitalExcess = param.hospitalExcess, productIds = param.productIds;
    return (0,fp.filter)(function(productId) {
        var idRegexMatch = productId.match(RegExp("excess-(?<excessAmount>\\d+)"));
        var excessAmount = (0,fp.get)("groups.excessAmount")(idRegexMatch);
        return hospitalExcess === excessAmount;
    })(productIds);
};
/* harmony default export */ var filter_ids_by_excess = (filterIdsByExcess);

// EXTERNAL MODULE: ./src/client/utils/get-saleable-product-ids-keyed-by-type/index.ts
var get_saleable_product_ids_keyed_by_type = __webpack_require__(20815);
;// CONCATENATED MODULE: ./src/client/utils/get-product-ids-from-needs/index.ts






var EXTRAS = src.NEEDS_PRODUCT_TYPE_SLUG.EXTRAS, HOSPITAL = src.NEEDS_PRODUCT_TYPE_SLUG.HOSPITAL, PACKAGE = src.NEEDS_PRODUCT_TYPE_SLUG.PACKAGE;
var getAllSaleableProducts = function() {
    var allSaleableProductsIds = (0,get_saleable_product_ids_keyed_by_type/* default */.Z)();
    // @ts-expect-error - Automatic, Please fix when editing this file
    var saleableProductIdsHospital = allSaleableProductsIds.hospital;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var saleableProductIdsExtras = allSaleableProductsIds.extras;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var saleableProductIdsPackage = allSaleableProductsIds.package;
    var saleableProductIdsCombined = (0,fp.flatMap)(function(hospitalId) {
        return (0,fp.map)(function(extrasId) {
            return "".concat(hospitalId, "-").concat(extrasId);
        })(saleableProductIdsExtras);
    })(saleableProductIdsHospital);
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    (0,_to_consumable_array/* default */.Z)(saleableProductIdsExtras).concat(// @ts-expect-error - Automatic, Please fix when editing this file
    (0,_to_consumable_array/* default */.Z)(saleableProductIdsHospital), // @ts-expect-error - Automatic, Please fix when editing this file
    (0,_to_consumable_array/* default */.Z)(saleableProductIdsPackage), (0,_to_consumable_array/* default */.Z)(saleableProductIdsCombined)));
};
// @ts-expect-error - Automatic, Please fix when editing this file
var getProductIdsFromNeeds = function(param) {
    var hospitalExcess = param.hospitalExcess, needsType = param.needsType, needsProductType = param.needsProductType;
    var listOfBundles = (0,fp.get)("".concat(needsType, ".").concat(needsProductType))(src.PRODUCTS_BY_NEEDS);
    var bundlesMappedToProductIds = (0,fp.flatMap)(function(bundle) {
        var productTypes = (0,fp.keys)(bundle);
        // has only an extras product
        if ((0,fp.isEqual)(productTypes, [
            EXTRAS
        ])) {
            // @ts-expect-error - Automatic, Please fix when editing this file
            return bundle[EXTRAS];
        }
        // hospital or package product
        // @ts-expect-error - Automatic, Please fix when editing this file
        var parentProduct = bundle[HOSPITAL] || bundle[PACKAGE];
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly "boost-basic-plus": readonly ["boost-basic-plus-excess-500", "boost-basic-plus-excess-750"]; readonly "boost-flexi-basic-plus": readonly ["boost-flexi-basic-plus-excess-500", "boost-flexi-basic-plus-excess-750"]; ... 32 more ...; readonly "simple-bronze-plus": readonly [...]; }'.
        var productIds = src.PRODUCTS_BY_PARENT[parentProduct];
        var idsToLoad = hospitalExcess ? filter_ids_by_excess({
            hospitalExcess: hospitalExcess,
            productIds: productIds
        }) : productIds;
        // @ts-expect-error - Automatic, Please fix when editing this file
        var hasComplementaryProduct = Boolean(bundle[EXTRAS]);
        if (!hasComplementaryProduct) {
            return idsToLoad;
        }
        // if it is a soft bundle concat the extras to the parent id
        // @ts-expect-error - Automatic, Please fix when editing this file
        return (0,fp.map)(function(productId) {
            return "".concat(productId, "-").concat(bundle[EXTRAS]);
        })(idsToLoad);
    })(listOfBundles);
    var productIdsAdjustedForChoosable = exclude_choosable_for_needs({
        needsProductType: needsProductType,
        needsType: needsType,
        productIds: bundlesMappedToProductIds
    });
    // Ensure we're not returning a list with non-saleable products in it.
    return (0,fp.filter)(function(productId) {
        return (0,fp.includes)(productId, getAllSaleableProducts());
    })(productIdsAdjustedForChoosable);
};
/* harmony default export */ var get_product_ids_from_needs = (getProductIdsFromNeeds);


/***/ }),

/***/ 591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);


// @ts-expect-error - Automatic, Please fix when editing this file
var isProductBestSeller = function(param) {
    var scale = param.scale, parentProductId = param.parentProductId, productId = param.productId, productType = param.productType;
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly hospital: { readonly single: "starter-bronze"; readonly couple: "simple-bronze-plus"; readonly family: "essentials-silver-plus"; readonly "single-parent": "core-bronze-plus"; }; readonly extras: { ...; }; readonly package: { ...; }; }'.
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.some)(function(id) {
        var ref;
        return id === (_ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST === null || _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST === void 0 ? void 0 : (ref = _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST[productType]) === null || ref === void 0 ? void 0 : ref[scale]);
    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)([
        parentProductId,
        productId
    ]));
};
/* harmony default export */ __webpack_exports__["Z"] = (isProductBestSeller);


/***/ }),

/***/ 7550:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__Vrua0"};

/***/ }),

/***/ 90937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__LLK5Q"};

/***/ })

}]);